import { getQuantidadePessoasAtendidas } from './functions.js'

/**
 * Filtra a lista de cadastros conforme os filtros selecionados.
 *
 * Amarelo: 2 ou menos atendimentos no período (da equipe filtrada).
 * Verde: 3 ou mais atendimentos no período (da equipe filtrada).
 *
 * @param {Array<Object>} cadastros Lista de cadastros a serem filtrados.
 * @param {Boolean} exibirVermelhos Indica se devem ser exibidos apenas os cadastros amarelos.
 * @param {Boolean} exibirVerdes Indica se devem ser exibidos apenas os cadastros verdes.
 * @param {Object} equipe Equipe selecionada.
 * @param {Object|null} mes Mês selecionado no filtro.
 *
 * @returns {Array<Object>} Lista de cadastros filtrados.
 */
export function filtro(
  cadastros,
  exibirVermelhos,
  exibirVerdes,
  equipe = null,
  mes = null
) {
  let cadastros_filtrados = cadastros

  if (exibirVermelhos === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      const quantidade = getQuantidadePessoasAtendidas(item, mes, equipe)
      return quantidade >= 1 && quantidade <= 2
    })
  }

  if (exibirVerdes === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      return getQuantidadePessoasAtendidas(item, mes, equipe) >= 3
    })
  }

  return cadastros_filtrados
}
